// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { AnalyticsStore, DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// mobx
import { UserAuthStore } from 'stores';

// util
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export interface TaapRedirectDialogProps {
  analytics?: AnalyticsStore;
  routeStore: RouteStore;
  userAuth?: UserAuthStore;
  l10n?: ILocalization;
}

export const TaapRedirectDialog: React.FunctionComponent<TaapRedirectDialogProps> = inject(
  'analytics',
  'userAuth',
)(({ analytics, routeStore, userAuth, l10n }) => {
  const dialogId = 'taap-redirect';
  const rfrrIdSelected = 'affhub_signup_taap.selected';
  const linkNameSelected = 'AffHub Sign Up TAAP Selected';

  const onDismiss = () => {
    routeStore.closeDialog();
  };

  const onClickProceed = () => {
    analytics.trackEvent(rfrrIdSelected, linkNameSelected, null, null, true, [
      getUserAnalyticsMicroMessage(userAuth?.currentUserDetails),
    ]);
    location.href = 'https://www.expedia.co.uk/TAAP-LearnMore';
  };

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogRedirect" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            <UitkDialogContent>
              <UitkSpacing margin={{ block: 'two' }}>
                <UitkText>
                  <LocalizedText message="signup.taap_dialog.text.specialized_affiliate_program" />
                </UitkText>
              </UitkSpacing>
            </UitkDialogContent>
            <UitkDialogFooter
              key="UitkDialogFooter"
              buttonOne={{
                onClick: onClickProceed,
                text: l10n.formatText('signup.taap_dialog.button.proceed'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
});
